export const translations = {
  es: {
    nav: {
      home: 'Inicio',
      music: 'Música',
      about: 'Sobre Mí',
      gallery: 'Galería',
      tour: 'Tour',
      shop: 'Tienda',
      contact: 'Contacto'
    },
    hero: {
      subtitle: 'MÚSICO • COMPOSITOR • ARTISTA',
      listenMusic: 'Escuchar Música',
      contact: 'Contacto',
      scrollDown: 'Scroll Down'
    },
    music: {
      title: 'Música',
      comingSoon: 'Próximamente',
      newAlbum: 'Nuevo Álbum en Camino',
      workingOn: 'En este momento estoy trabajando en mi próximo álbum que promete ser una experiencia musical única.',
      stayTuned: '¡Mantente atento a las actualizaciones!',
      availableSoon: 'Disponible próximamente en:'
    },
    about: {
      title: 'Sobre Mí',
      quote: 'La música es el lenguaje universal que conecta almas y trasciende fronteras.',
      name: 'Jonathan Pérez',
      role: 'Músico y Compositor',
      bio1: 'Soy un creador musical en constante exploración, apasionado por las melodías que emocionan y las letras que cuentan historias que conectan.',
      bio2: 'Mi música nace de la curiosidad, la experimentación y el deseo de transmitir lo que siento, fusionando sonidos y estilos de formas únicas que buscan tocar el corazón de quien la escucha.',
      guitar: 'Instrumentos',
      vocal: 'Vocal',
      composition: 'Composición'
    },
    gallery: {
      title: 'Galería',
      intro: 'Una colección de momentos especiales, sesiones de estudio y presentaciones en vivo.',
      studioSessions: 'Sesiones de Estudio',
      studioDesc: 'Detrás de cámaras en el proceso creativo',
      liveConcerts: 'Conciertos en Vivo',
      liveDesc: 'Momentos únicos con el público',
      creativeProcess: 'Proceso Creativo',
      creativeDesc: 'El arte de crear música',
      instruments: 'Instrumentos',
      instrumentsDesc: 'Las herramientas de mi arte',
      collaborations: 'Colaboraciones',
      collaborationsDesc: 'Trabajando con otros artistas',
      specialMoments: 'Momentos Especiales',
      specialDesc: 'Recuerdos inolvidables',
      followSocial: '¡Sígueme en redes sociales!',
      socialDesc: 'No te pierdas las últimas fotos y videos. Sígueme en mis redes sociales para contenido exclusivo y actualizaciones diarias.',
      connect: 'Conectar'
    },
    tour: {
      title: 'Tour',
      upcomingDates: 'Próximas Fechas',
      tourAnnouncement: 'Estoy emocionado de anunciar que pronto estaré de gira. Mantente atento para conocer las fechas y ciudades donde nos encontraremos.',
      notifications: 'Notificaciones de Tour',
      firstToKnow: 'Sé el primero en enterarte de las nuevas fechas',
      emailPlaceholder: 'Tu email',
      notifyMe: 'Notificarme',
      thankYou: '¡Gracias! Te notificaremos sobre las nuevas fechas.'
    },
    shop: {
      title: 'Tienda',
      intro: 'Próximamente podrás encontrar merchandise oficial, música física y productos exclusivos.',
      upcomingProducts: 'Productos Próximamente',
      clothing: 'Ropa',
      officialShirts: 'Camisetas Oficiales',
      uniqueDesigns: 'Diseños únicos y exclusivos',
      music: 'Música',
      physicalAlbums: 'Álbumes Físicos',
      limitedEditions: 'Ediciones limitadas en vinilo y CD',
      accessories: 'Accesorios',
      mugsMore: 'Tazas y Más',
      dailyProducts: 'Productos para el día a día',
      instruments: 'Instrumentos',
      customPicks: 'Picks Personalizados',
      signaturePicks: 'Púas con mi firma',
      firstToBuy: '¡Sé el primero en comprar!',
      registerNotifications: 'Regístrate para recibir notificaciones cuando la tienda esté disponible y obtén descuentos exclusivos.',
      perfectNotify: '¡Perfecto! Te avisaremos cuando esté lista.'
    },
    contact: {
      title: 'Contacto',
      letsConnect: 'Conectemos',
      contactDesc: '¿Tienes una propuesta, quieres colaborar o simplemente saludar? Me encantaría escucharte.',
      email: 'Email',
      phone: 'Teléfono',
      location: 'Ubicación',
      followMe: 'Sígueme',
      sendMessage: 'Envíame un Mensaje',
      messageSent: '¡Mensaje enviado! Te responderé pronto.',
      name: 'Nombre',
      message: 'Mensaje',
      sendBtn: 'Enviar Mensaje'
    },
    footer: {
      tagline: 'Músico • Compositor • Artista',
      description: 'Creando música que conecta corazones y trasciende fronteras. Únete a este viaje musical extraordinario.',
      stayConnected: 'Mantente Conectado',
      firstToKnow: 'Sé el primero en conocer mis nuevos lanzamientos y conciertos',
      subscribe: 'Suscribirse',
      welcomeFamily: '¡Bienvenido a la familia musical!',
      navigation: 'Navegación',
      home: 'Inicio',
      socialNetworks: 'Redes Sociales',
      streaming: 'Streaming',
      copyright: '© 2025 Jonathan Pérez. Todos los derechos reservados.',
      privacyPolicy: 'Política de Privacidad',
      termsOfUse: 'Términos de Uso',
      cookies: 'Cookies',
      backToTop: 'Volver Arriba',
      madeWith: 'Hecho con',
      and: 'y mucha',
      by: 'por Jonathan Pérez'
    }
  },
  en: {
    nav: {
      home: 'Home',
      music: 'Music',
      about: 'About',
      gallery: 'Gallery',
      tour: 'Tour',
      shop: 'Shop',
      contact: 'Contact'
    },
    hero: {
      subtitle: 'MUSICIAN • COMPOSER • ARTIST',
      listenMusic: 'Listen to Music',
      contact: 'Contact',
      scrollDown: 'Scroll Down'
    },
    music: {
      title: 'Music',
      comingSoon: 'Coming Soon',
      newAlbum: 'New Album on the Way',
      workingOn: 'I am currently working on my next album that promises to be a unique musical experience.',
      stayTuned: 'Stay tuned for updates!',
      availableSoon: 'Coming soon on:'
    },
    about: {
      title: 'About Me',
      quote: 'Music is the universal language that connects souls and transcends borders.',
      name: 'Jonathan Pérez',
      role: 'Musician and Composer',
      bio1: 'I’m a musical creator in constant exploration, passionate about melodies that move the heart and lyrics that tell stories connecting with people.',
      bio2: 'My music comes from curiosity, experimentation, and the desire to express what I feel, blending sounds and styles in unique ways that aim to touch anyone who listens.',
      guitar: 'Instruments',
      vocal: 'Vocal',
      composition: 'Composition'
    },
    gallery: {
      title: 'Gallery',
      intro: 'A collection of special moments, studio sessions and live performances.',
      studioSessions: 'Studio Sessions',
      studioDesc: 'Behind the scenes in the creative process',
      liveConcerts: 'Live Concerts',
      liveDesc: 'Unique moments with the audience',
      creativeProcess: 'Creative Process',
      creativeDesc: 'The art of making music',
      instruments: 'Instruments',
      instrumentsDesc: 'The tools of my art',
      collaborations: 'Collaborations',
      collaborationsDesc: 'Working with other artists',
      specialMoments: 'Special Moments',
      specialDesc: 'Unforgettable memories',
      followSocial: 'Follow me on social media!',
      socialDesc: 'Don\'t miss the latest photos and videos. Follow me on my social networks for exclusive content and daily updates.',
      connect: 'Connect'
    },
    tour: {
      title: 'Tour',
      upcomingDates: 'Upcoming Dates',
      tourAnnouncement: 'I am excited to announce that I will be touring soon. Stay tuned to know the dates and cities where we will meet.',
      notifications: 'Tour Notifications',
      firstToKnow: 'Be the first to know about new dates',
      emailPlaceholder: 'Your email',
      notifyMe: 'Notify Me',
      thankYou: 'Thank you! We will notify you about new dates.'
    },
    shop: {
      title: 'Shop',
      intro: 'Soon you will be able to find official merchandise, physical music and exclusive products.',
      upcomingProducts: 'Products Coming Soon',
      clothing: 'Clothing',
      officialShirts: 'Official T-Shirts',
      uniqueDesigns: 'Unique and exclusive designs',
      music: 'Music',
      physicalAlbums: 'Physical Albums',
      limitedEditions: 'Limited editions on vinyl and CD',
      accessories: 'Accessories',
      mugsMore: 'Mugs and More',
      dailyProducts: 'Products for everyday use',
      instruments: 'Instruments',
      customPicks: 'Custom Picks',
      signaturePicks: 'Picks with my signature',
      firstToBuy: 'Be the first to buy!',
      registerNotifications: 'Register to receive notifications when the store is available and get exclusive discounts.',
      perfectNotify: 'Perfect! We\'ll let you know when it\'s ready.'
    },
    contact: {
      title: 'Contact',
      letsConnect: 'Let\'s Connect',
      contactDesc: 'Do you have a proposal, want to collaborate or just say hello? I would love to hear from you.',
      email: 'Email',
      phone: 'Phone',
      location: 'Location',
      followMe: 'Follow Me',
      sendMessage: 'Send Me a Message',
      messageSent: 'Message sent! I will respond soon.',
      name: 'Name',
      message: 'Message',
      sendBtn: 'Send Message'
    },
    footer: {
      tagline: 'Musician • Composer • Artist',
      description: 'Creating music that connects hearts and transcends borders. Join this extraordinary musical journey.',
      stayConnected: 'Stay Connected',
      firstToKnow: 'Be the first to know about my new releases and concerts',
      subscribe: 'Subscribe',
      welcomeFamily: 'Welcome to the musical family!',
      navigation: 'Navigation',
      home: 'Home',
      socialNetworks: 'Social Networks',
      streaming: 'Streaming',
      copyright: '© 2025 Jonathan Pérez. All rights reserved.',
      privacyPolicy: 'Privacy Policy',
      termsOfUse: 'Terms of Use',
      cookies: 'Cookies',
      backToTop: 'Back to Top',
      madeWith: 'Made with',
      and: 'and lots of',
      by: 'by Jonathan Pérez'
    }
  }
};